"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParamsBuilder = exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _EnvironmentUrl = _interopRequireDefault(require("../config/environment/EnvironmentUrl"));

var _AaJwtTokenProvider = _interopRequireDefault(require("./AaJwtTokenProvider"));

var _AaHelpers = require("./AaHelpers");

var createParamsBuilder = function createParamsBuilder(environment, clientId) {
  var tokenProvider = (0, _AaJwtTokenProvider["default"])(environment);
  var environmentUrls = _EnvironmentUrl["default"][environment];
  var urls = {
    GET_SUGGESTION: environmentUrls.HOTEL_SUGGESTION_ENDPOINT,
    GET_SUGGESTIONS: environmentUrls.HOTEL_SUGGESTIONS_ENDPOINT
  };

  var buildHeaders = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var token;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return tokenProvider.getToken();

            case 2:
              token = _context.sent;
              return _context.abrupt("return", {
                'Client-ID': clientId,
                authorization: "Bearer ".concat(token)
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function buildHeaders() {
      return _ref.apply(this, arguments);
    };
  }();

  var getSuggestionUrl = function getSuggestionUrl(id, locale) {
    return (0, _AaHelpers.format)(urls.GET_SUGGESTION, [id, locale]);
  };

  var getSuggestionsUrl = function getSuggestionsUrl(query, locale) {
    return (0, _AaHelpers.format)(urls.GET_SUGGESTIONS, [query, locale]);
  };

  paramsBuilder = {
    getSuggestionUrl: getSuggestionUrl,
    getSuggestionsUrl: getSuggestionsUrl,
    buildHeaders: buildHeaders
  };
  return paramsBuilder;
};

var paramsBuilder;

var getParamsBuilder = function getParamsBuilder() {
  return paramsBuilder;
};

exports.getParamsBuilder = getParamsBuilder;
var _default = {
  create: createParamsBuilder,
  getParamsBuilder: getParamsBuilder
};
exports["default"] = _default;